import React, { useEffect, useState, useCallback } from "react";
import { CancelRequest } from "../../services/AxiosInstance";
import DataTable from "react-data-table-component";
import { Spinner } from "react-bootstrap";
import { Link } from "react-router-dom";
import { format } from "date-fns";
import { MediaGroup, Media, MediaText, Image } from "../../components";
import { getPassListApi } from "../../services/TransportService";
import { toInitials, perPageOptions, userStatusOptions } from "../../utilities";
import { debounce } from "lodash";
import DebounceSearchInput from "../Constant/DebounceSearchInput";
import { StaticSelectInput } from "../Constant/SelectInput";
import Pagination from "../Constant/Pagination";
function PassListPage() {
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [filter, setFilter] = useState({
    page: 1,
    page_size: 10,
    query: "",
    status: "",
  });

  const handleSearchChange = debounce((value) => {
    CancelRequest();
    setFilter((prev) => ({
      ...prev,
      query: value,
      page: 1,
    }));
  }, 100);

  const fetchData = useCallback(() => {
    CancelRequest();
    setIsLoading(true);
    const queryParams = {
      page: filter.page,
      page_size: filter.page_size,
      query: filter.query,
      status: filter.status,
    };
    getPassListApi(queryParams)
      .then((resp) => {
        const allUsers = resp.data.results;
        setData(allUsers);
        setTotal(resp.data.count);
      })
      .catch((error) => {
        console.error(error.response?.data?.message);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [filter.query, filter.page, filter.page_size, filter.status]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handlePagination = (page) => {
    setFilter((prev) => ({
      ...prev,
      page: page.selected + 1,
    }));
  };

  const handleSelectChange = (name, value) => {
    setFilter((prev) => ({
      ...prev,
      [name]: value,
      page: 1,
    }));
  };

  const columns = [
    {
      name: "Employee",
      selector: (row) => (
        <MediaGroup>
          <Media size="md" shape="circle" variant="dark-soft">
            {row?.employee?.profile_photo ? (
              <Image
                src={`${process.env.REACT_APP_BASE_URL}${row?.employee?.profile_photo}`}
                staticImage
                alt="user"
              />
            ) : (
              <span className="fw-medium">
                {toInitials(row?.employee.name)}
              </span>
            )}
          </Media>

          <MediaText>
            <Link
              to={`/employee/${row?.employee.id}`}
              className="title text-uppercase text-primary"
            >
              <strong>{row?.employee.name}</strong>{" "}
            </Link>
            <Link to={`/employee/${row?.employee.id}`}>
              <span className="small text">{row?.employee.email}</span>
            </Link>
          </MediaText>
        </MediaGroup>
      ),
      wrap: true,
      grow: 2,
    },
    {
      name: "Route",
      selector: (row) => row.route?.route_number || "-",
      wrap: true,
    },
    {
      name: "Bus",
      selector: (row) => {
        const start = new Date(`1970-01-01T${row.departure_time}`);
        return `${row.bus.number_plate} [${format(start, "h.mm a")}]`;
      },
      wrap: true,
    },
    {
      name: "Stop",
      selector: (row) => row.route.stop,
      grow: 2,
      wrap: true,
    },
    {
      name: "Validity",
      selector: (row) =>
        `${format(new Date(row.start_date), "d MMMM yyyy")}  To ${format(
          new Date(row.end_date),
          "d MMMM yyyy"
        )}`,
      wrap: true,
      sortable: false,
    },
    {
      name: "Status",
      selector: (row) => row.status,
      sortable: true,
      cell: (row) => (
        <span
          className={`badge text-bg-${
            row?.status?.toLowerCase() === "active"
              ? "success-soft"
              : "danger-soft"
          }`}
        >
          {row?.status}
        </span>
      ),
    },
  ];

  return (
    <div className="container-fluid">
      <div className="d-flex flex-column flex-md-row justify-content-between">
        <div>
          <span
            className="text-primary"
            style={{ fontSize: "1.2rem", fontWeight: "500" }}
          >
            Passes
          </span>
          <ol className="breadcrumb breadcrumb-arrow mb-0">
            <li className="breadcrumb-item">
              <Link to="/dashboard">Dashboard</Link>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              Passes
            </li>
          </ol>
        </div>
        <div className="d-flex flex-column flex-md-row gap-2">
          <div>
            <DebounceSearchInput handleSearchChange={handleSearchChange} />
          </div>
          {/* <div>
            <StaticSelectInput
              setParentInputValue={handleSelectChange}
              optionsList={userStatusOptions}
              name="status"
              id="status"
              parentClassName="mt-0"
              isClearable={true}
              placeholder="Select Status"
            />
          </div> */}
          {/* <div>
                     <StaticSelectInput
                  setParentInputValue={handleSelectChange}
                  optionsList={perPageOptions}
                  name="page_size"
                  id="page_size"
                  parentClassName="mt-0"
                  isClearable={false}
                  placeholder="Per Page"
                />
                  </div> */}
        </div>
      </div>
      <div className="row mt-4">
        <div className="col">
          <div className="card">
            {/* <DataTable
              columns={columns}
              data={data}
              noDataComponent={
                <div className="p-2">There are no records found.</div>
              }
              sortIcon={<div className="data-table-sorter"></div>}
              progressPending={isLoading}
              progressComponent={
                <div className="text-center my-4">
                  <Spinner animation="border" variant="primary" />
                </div>
              }
              pagination
              paginationPerPage={filter.page_size}
              paginationComponent={(props) => (
                <div className="data-table-bottom">
                  <Pagination
                    currentPage={filter.page}
                    recordsPage={filter.page_size}
                    dataLength={total}
                    handlePagination={handlePagination}
                  />
                </div>
              )}
            /> */}
            <div>
              {isLoading ? (
                <div className="text-center my-4">
                  <Spinner animation="border" variant="primary" />
                </div>
              ) : data?.length === 0 ? (
                <div className="my-4 text-center">
                  There are no records found.
                </div>
              ) : (
                <div className="table-responsive">
                  <table className="table fs-6 mb-0 align-middle">
                    <thead className="custom-thead table-light">
                      <tr>
                        <th>Employee</th>
                        <th>Route</th>
                        <th>Bus</th>
                        <th>Stop</th>
                        <th>Validity</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data.map((row, idx) => {
                        // const start = new Date(
                        //   `1970-01-01T${row.departure_time}`
                        // );
                        return (
                          <tr key={idx}>
                            <td>
                              <div className="d-flex align-items-center">
                                {row?.employee?.profile_photo ? (
                                  <img
                                    src={`${process.env.REACT_APP_BASE_URL}${row?.employee?.profile_photo}`}
                                    alt="user"
                                    className="rounded-circle me-2"
                                    width={35}
                                    height={35}
                                  />
                                ) : (
                                  <div
                                    className="bg-secondary text-white rounded-circle d-flex align-items-center justify-content-center me-2"
                                    style={{ width: 35, height: 35 }}
                                  >
                                    <span className="fw-bold">
                                      {toInitials(row?.employee?.name)}
                                    </span>
                                  </div>
                                )}
                                <div>
                                  <Link
                                    to={`/employee/${row?.employee.id}`}
                                    className="fw-bold text-uppercase text-primary d-block"
                                  >
                                    {row?.employee.name}
                                  </Link>
                                  <Link to={`/employee/${row?.employee.id}`}>
                                    <span className="text-secondary small">
                                      {row?.employee.email}
                                    </span>
                                  </Link>
                                </div>
                              </div>
                            </td>

                            <td>{row.route?.route_number || "-"}</td>

                            <td>
                              {row.bus.number_plate}
                              {/* [{format(start, "hh mm a")}] */}
                            </td>

                            <td>{row?.stop?.name}</td>

                            <td>
                              {format(new Date(row.start_date), "d MMMM yyyy")}{" "}
                              To {format(new Date(row.end_date), "d MMMM yyyy")}
                            </td>

                            <td>
                              <span
                                className={`badge text-bg-${
                                  row?.status?.toLowerCase() === "active"
                                    ? "success-soft"
                                    : "danger-soft"
                                }`}
                              >
                                {row?.status}
                              </span>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              )}

              {/* Pagination Component */}
              {!isLoading && data?.length > 0 && (
                <div className="border-top p-4">
                  <Pagination
                    currentPage={filter.page}
                    recordsPage={filter.page_size}
                    dataLength={total}
                    handlePagination={handlePagination}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PassListPage;
